import { memo, Fragment } from "react";

// eslint-disable-next-line @bigbinary/neeto/use-webpack-alias
import { Kbd, Typography } from "@bigbinary/neetoui";

import {
  convertHotkeyToUsersPlatform,
  shortenHotKey,
  getTooltipProps,
} from "./utils";

const HotKey = ({ description, sequence }) => {
  const hotkey = shortenHotKey(convertHotkeyToUsersPlatform(sequence));
  const isSequentialHotkey = hotkey.includes(" ");
  const isSimultaneousHotkey = hotkey.includes("+");
  const isSingleKeyHotkey = !isSequentialHotkey && !isSimultaneousHotkey;
  let sequences = [];

  if (isSingleKeyHotkey) {
    sequences = [hotkey];
  } else if (isSequentialHotkey) {
    sequences = hotkey.split(" ");
  } else if (isSimultaneousHotkey) {
    sequences = hotkey.split("+");
  }

  return (
    <div className="my-3 w-full">
      <div
        className="flex items-center justify-between gap-3"
        data-testid="hotkey-item"
      >
        <Typography
          className="neeto-ui-text-gray-800 min-w-0 flex-grow break-words"
          lineHeight="normal"
          style="body2"
        >
          {description}
        </Typography>
        <div className="flex flex-shrink-0 items-center gap-1">
          {sequences.map((keyName, idx) => (
            <Fragment key={idx}>
              <Kbd {...{ keyName }} tooltipProps={getTooltipProps(keyName)} />
              {isSequentialHotkey && idx + 1 !== sequences.length && (
                <Kbd keyName="then" />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(HotKey);
